import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuHorizontal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.8871 10C11.8871 11.1056 11.0431 12 10 12C8.95685 12 8.1129 11.1056 8.1129 10C8.1129 8.89444 8.95685 8 10 8C11.0431 8 11.8871 8.89444 11.8871 10ZM15.6129 8C14.5698 8 13.7258 8.89444 13.7258 10C13.7258 11.1056 14.5698 12 15.6129 12C16.656 12 17.5 11.1056 17.5 10C17.5 8.89444 16.656 8 15.6129 8ZM4.3871 8C3.34395 8 2.5 8.89444 2.5 10C2.5 11.1056 3.34395 12 4.3871 12C5.43024 12 6.27419 11.1056 6.27419 10C6.27419 8.89444 5.43024 8 4.3871 8Z",
		fill: "#0D2976"
	})
});
export default SvgMenuHorizontal;
